import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListItemSetting } from './ListItemSetting'
import { newConnection, setConnection } from '../helpers/connectionHelper'
import { emit } from '../services/Controller'

export const ConnectionLogSetting: React.FC<{ service: IService; connection?: IConnection }> = ({
  service,
  connection,
}) => {
  const { t } = useTranslation()
  if (!service) return null
  if (!connection) connection = newConnection(service)
  const disabled = connection.connected || connection.public
  const log = connection.public ? false : connection.log

  return (
    <ListItemSetting
      label={t('connectionLogSetting.label', 'Connection Logging')}
      subLabel={log ? `${connection.id.replace(/:/g, '')}_<timestamp>.log` : undefined}
      modified={log}
      disabled={disabled}
      icon="file-alt"
      toggle={!!log}
      button={log ? t('connectionLogSetting.showLog', 'Show Log') : undefined}
      onButtonClick={() => emit('showFolder', 'connections')}
      onClick={() =>
        connection &&
        setConnection({
          ...connection,
          log: !connection.log,
        })
      }
    />
  )
}
